import { render, staticRenderFns } from "./scene-aspect.vue?vue&type=template&id=d06f876e&scoped=true&"
import script from "./scene-aspect.vue?vue&type=script&lang=js&"
export * from "./scene-aspect.vue?vue&type=script&lang=js&"
import style0 from "./scene-aspect.vue?vue&type=style&index=0&id=d06f876e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06f876e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/fcs/fcs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d06f876e')) {
      api.createRecord('d06f876e', component.options)
    } else {
      api.reload('d06f876e', component.options)
    }
    module.hot.accept("./scene-aspect.vue?vue&type=template&id=d06f876e&scoped=true&", function () {
      api.rerender('d06f876e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/scene-aspect.vue"
export default component.exports